import { LeaguePracticeRespType } from 'types/league/leaguePractice'
import { create } from 'zustand'

const leaguePracticeStoreStates = (set: any) => ({
  addPracticeModal: false,
  setAddPracticeModal: (state: boolean) =>
    set(() => ({ addPracticeModal: state })),

  selectedPractice: null as LeaguePracticeRespType | null,
  setSelectedPractice: (state: LeaguePracticeRespType | null) =>
    set(() => ({ selectedPractice: state })),
})

export const leaguePracticeStore = create(leaguePracticeStoreStates)
